import { __require as _ } from "./main34.js";
import { __require as o } from "./main36.js";
var r, e;
function q() {
  if (e) return r;
  e = 1;
  var a = _(), i = o(), t = a(i, "Map");
  return r = t, r;
}
export {
  q as __require
};
